<template>
  <div class="bind-phone">
    <h1>绑定手机</h1>
    <h2>BINDING MOBILE PHONE</h2>
    <div class="qr-corner" @click="goScan">
      <img src="../../assets/qr-corner.png" alt>
    </div>
    <div class="bind-phone-form form-wrap">
      <!-- <div class="input-wrap">
        <label>用户名</label>
        <input type="text" v-model="UserName">
      </div>-->
      <div class="input-wrap">
        <label>手机号</label>
        <input type="text" v-model="PhoneNumber" v-focus="true">
      </div>
      <div class="input-wrap">
        <label>验证码</label>
        <input type="text" v-model="AuthCode" class="qr-input">
        <a v-if="!qrLoading" class="qrcode" @click="fetchCode">获取验证码</a>
        <p v-else class="qr-loading">已发送({{loadSeconds}}s)</p>
      </div>
      <div class="input-wrap">
        <label>密码</label>
        <input type="password" v-model="PassWord">
      </div>
      <button
        class="login-btn"
        :class="{'grey-btn':greyBtn}"
        @click="bindPhone"
      >{{binded?'该手机号已注册，直接绑定':'绑定手机'}}</button>
      <p class="tip">
        <span>已有账号？去</span>
        <a class="sign-link" @click="signIn">登录</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bindPhone',
  data() {
    return {
      PhoneNumber: '',
      // UserName: '',
      AuthCode: '',
      PassWord: '',
      loadSeconds: 60,
      qrLoading: false,
      interval: null,
      binded: false
    }
  },
  computed: {
    greyBtn() {
      let { PhoneNumber, AuthCode, PassWord } = this
      return !(PhoneNumber && AuthCode && PassWord)
    }
  },
  methods: {
    fetchCode() {
      this.$store
        .dispatch('FetchScanCode', this.PhoneNumber)
        .then(res => {
          this.$message({
            message: '短信发送成功',
            type: 'success'
          })
          this.binded = res.Data
          this.countLoadSeconds()
        })
        .catch(() => {})
    },
    bindPhone() {
      let { PhoneNumber, AuthCode, PassWord } = this
      let userInfo = {
        UnionId: this.$store.getters.unionId,
        PhoneNumber,
        UserName: PhoneNumber,
        AuthCode,
        PassWord
      }
      this.$store
        .dispatch('ScanRegister', userInfo)
        .then(() => {
          this.$message({
            message: '绑定成功',
            type: 'success'
          })
          this.$store
            .dispatch('LoginByPhone', { PhoneNumber, PassWord })
            .then(() => {
              this.$router.push({ path: '/' })
            })
        })
        .catch(() => {})
    },
    // goHome() {
    //   this.$router.push({ path: '/' })
    // },
    signIn() {
      this.$router.push({ path: '/login' })
    },
    countLoadSeconds() {
      if (this.loadSeconds > 0) {
        this.qrLoading = true
        this.interval = setInterval(() => {
          this.loadSeconds--
        }, 1000)
      }
    },
    goScan() {
      this.$router.push({ path: '/login/qr-sign-in' })
    }
  },
  watch: {
    loadSeconds(val) {
      if (val < 0) {
        this.qrLoading = false
        clearInterval(this.interval)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.login-wrap .login-box .right .login-btn.grey-btn {
  background-color: #a4a8ab;
  color: #ffffff;
  width: 90%;
}
</style>
